"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarButtons = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const ui_1 = require("@completeanatomy/ui");
const HomeButton_1 = require("../../molecules/HomeButton");
const RedoButton_1 = require("../../molecules/RedoButton");
const UndoButton_1 = require("../../molecules/UndoButton");
const UndoRedoDropdown_1 = __importDefault(require("../../molecules/UndoRedoDropdown"));
var ToolbarButtons;
(function (ToolbarButtons) {
    ToolbarButtons[ToolbarButtons["Home"] = 0] = "Home";
    ToolbarButtons[ToolbarButtons["Undo"] = 1] = "Undo";
    ToolbarButtons[ToolbarButtons["Redo"] = 2] = "Redo";
})(ToolbarButtons || (exports.ToolbarButtons = ToolbarButtons = {}));
function HistoryNavigation({ className, isToolsMode = false, }) {
    const [dropdownTriggeredBy, setDropdownTriggeredBy] = (0, react_1.useState)(null);
    const hideDropdown = (0, react_1.useCallback)(() => {
        setDropdownTriggeredBy(null);
    }, [setDropdownTriggeredBy]);
    const longPressByUndo = (0, react_1.useCallback)(() => {
        if (isToolsMode) {
            return;
        }
        setDropdownTriggeredBy(ToolbarButtons.Undo);
    }, [isToolsMode]);
    const longPressByRedo = (0, react_1.useCallback)(() => {
        if (isToolsMode) {
            return;
        }
        setDropdownTriggeredBy(ToolbarButtons.Redo);
    }, [isToolsMode]);
    const selectedUndo = dropdownTriggeredBy === ToolbarButtons.Undo;
    const selectedRedo = dropdownTriggeredBy === ToolbarButtons.Redo;
    const isUndoMenu = dropdownTriggeredBy === ToolbarButtons.Undo;
    const visible = dropdownTriggeredBy !== null;
    return ((0, jsx_runtime_1.jsxs)(ButtonContainer, { className: className, "data-e2e": 'HistoryNavigation_ButtonContainer', children: [!isToolsMode && (0, jsx_runtime_1.jsx)(HomeButton_1.HomeButton, { "data-e2e": 'HistoryNavigation_HomeButton' }), (0, jsx_runtime_1.jsx)(UndoButton_1.UndoButton, { onLongPress: longPressByUndo, selected: selectedUndo, isToolsMode: isToolsMode, "data-e2e": 'HistoryNavigation_UndoButton' }), (0, jsx_runtime_1.jsx)(RedoButton_1.RedoButton, { onLongPress: longPressByRedo, selected: selectedRedo, isToolsMode: isToolsMode, "data-e2e": 'HistoryNavigation_RedoButton' }), !isToolsMode && ((0, jsx_runtime_1.jsx)(UndoRedoDropdown_1.default, { isUndoMenu: isUndoMenu, visible: visible, hideDropdownCb: hideDropdown, "data-e2e": 'HistoryNavigation_UndoRedoDropDown' }))] }));
}
exports.default = (0, bridge_1.withBridgeProvider)(HistoryNavigation);
const ButtonContainer = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;

  ${ui_1.devicePortrait.all((0, styled_components_1.css) `
    height: 56px;
  `)}

  ${ui_1.device.tablet((0, styled_components_1.css) `
    height: 56px;
    margin: 0;
  `)}

  transition: transform 0.2s ease-in-out;

  pointer-events: initial;

  &.enter {
    transform: translateY(-100%);
  }

  &.enter-active {
    transform: translateY(0);
  }

  &.exit-active {
    transform: translateY(-100%);
  }
`;
